import script from "./SwanPayContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwanPayContainer.vue?vue&type=script&setup=true&lang=ts"

import "./SwanPayContainer.vue?vue&type=style&index=0&id=7069db3c&lang=scss"

const __exports__ = script;

export default __exports__